import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class DateService {
  // Ex : 2019-04-09T22:00:00
  getDateFromString(dateString: string): Date | null {
    if (dateString) {
      let date = new Date(dateString);
      date.setHours(0, 0, 0, 0); // AJout pour le filtre par periode dans projet
      return date;
    }
    return null;
  }

  getDateTimeFromString(dateString: string): Date | null {
    return dateString ? new Date(dateString) : null;
  }

  getStringFromDate(dateDate: Date): string | null {
    if (dateDate) {
      let dateOk: Date = dateDate;
      let year = dateOk.getFullYear();
      let month = this.padStart(`${dateOk.getMonth() + 1}`, 2, '0');
      let day = this.padStart(`${dateOk.getDate()}`, 2, '0');
      return `${year}-${month}-${day}T00:00:00`;
    }
    return null;
  }

  padStart(st: string, targetLength: number, padString?: string) {
    targetLength = targetLength >> 0; //truncate if number or convert non-number to 0;
    padString = String(typeof padString !== 'undefined' ? padString : ' ');
    if (st.length > targetLength) {
      return String(st);
    } else {
      targetLength = targetLength - st.length;
      if (targetLength > padString.length) {
        padString += padString.repeat(targetLength / padString.length); //append to original to ensure we are longer than needed
      }
      return padString.slice(0, targetLength) + String(st);
    }
  }

  getDateWthoutTime(dateTime: Date): Date {
    if (dateTime) {
      let date = new Date(dateTime.getTime());
      date.setHours(0, 0, 0, 0);
      return date;
    }
    return null;
  }

  dateDiffInDay(date1: Date, date2: Date): number {
    if (date1 && date2) {
      let diff = Math.abs(date2.getTime() - date1.getTime());
      return Math.ceil(diff / (1000 * 3600 * 24));
    }
    return null;
  }

  dateDiffInDayFromNow(date: Date): number {
    if (date) {
      let diff = date.getTime() - new Date().getTime();
      return Math.ceil(diff / (1000 * 3600 * 24));
    }
    return null;
  }

  getCurrentDateDdMmYy(): string {
    let dateT = new Date();
    let day = dateT.getDate().toString();
    let month = (dateT.getMonth() + 1).toString();
    let year = dateT.getFullYear().toString();
    return day + month + year;
  }

  isToday(date: string): boolean {
    if (date) {
      const today = new Date();
      const theDate = this.getDateFromString(date);
      return today.toDateString() === theDate.toDateString();
    }
    return false;
  }

  getCurrentYear(delta: number = 0): number {
    return new Date().getFullYear() + delta;
  }
}
